import { ChatMessage, ChatbotState } from '../states/chatbot'
import {
	ChatbotActionTypes,
	APPEND_SIMPLE_BOT_MESSAGE,
	UPDATE_STREAMING_BOT_MESSAGE,
	END_BOT_STREAMING,
	SET_BOT_TYPING,
	SET_CONVERSATION_ID,
	STOP_STREAMING,
	RESET_CONVERSATION,
} from '../actions/chatbot'

export const CHATBOT_REDUCER_NAMESPACE = 'chatbotReducer'

const initialState: ChatbotState = {
	messages: [],
	isTyping: false,
	conversation_id: undefined,
}

export const chatbotReducer = (
	state = initialState,
	action: ChatbotActionTypes
): ChatbotState => {
	switch (action.type) {
		case APPEND_SIMPLE_BOT_MESSAGE:
			return {
				...state,
				messages: [...state.messages, action.payload],
			}
		case UPDATE_STREAMING_BOT_MESSAGE:
			return {
				...state,
				messages: state.messages.map((message) =>
					message.id === action.payload.id
						? {
								...message,
								text: action.payload.text,
								isTyping: action.payload.isTyping,
						  }
						: message
				),
			}
		case END_BOT_STREAMING:
			return {
				...state,
				messages: state.messages.map((message) =>
					message.id === action.payload.id
						? {
								...message,
								text: action.payload.text,
								isTyping: false,
						  }
						: message
				),
			}
		case SET_BOT_TYPING:
			return {
				...state,
				isTyping: action.payload,
			}
		case SET_CONVERSATION_ID:
			return {
				...state,
				conversation_id: action.payload,
			}
		case STOP_STREAMING:
			return {
				...state,
				messages: state.messages.map((msg) =>
					msg.isTyping ||
					(action.payload && msg.id === action.payload.id)
						? {
								...msg,
								isTyping: false,
								text:
									action.payload &&
									msg.id === action.payload.id
										? action.payload.text
										: msg.text,
						  }
						: msg
				),
			}
		case RESET_CONVERSATION:
			return {
				...initialState,
			}
		default:
			return state
	}
}
